import { IAccount } from './account.type';
import { IBaseQuery } from './common.type';

export interface INotification {
  id: string;
  title?: string;
  content?: string;
  sender?: string;
  receiver?: string;
  type: ENotificationType;
  reference_id?: string;
  seen: number;
  created_at: string;
  user_sender: IAccount;
  user_receiver: IAccount;
}

export enum ENotificationType {
  SHARE = 'SHARE',
}

export interface INotificationQuery extends IBaseQuery {}
